// Icons each page uses, fetched once the page has loaded so that menus,
// dialogs and buttons shown later never draw an icon a moment after the rest.
// worker/test/icons.test.ts checks these lists against the pages' sources.

export const APP_ICONS = [
  "angle-down-solid",
  "arrow-rotate-left-solid",
  "check-solid",
  "download-solid",
  "draw-polygon-solid",
  "ellipsis-solid",
  "file-export-solid",
  "filter-solid",
  "floppy-disk-regular",
  "folder-open-regular",
  "heart-solid",
  "house-solid",
  "match-case",
  "match-case-off",
  "mug-hot-solid",
  "right-from-bracket-solid",
  "sort-solid",
  "table-cells-large-solid",
  "user-shield-solid",
  "user-solid",
  "wand-magic-sparkles-solid",
  "wrench-solid",
];

export const ADMIN_ICONS = [
  "angle-down-solid",
  "arrow-rotate-left-solid",
  "ban-solid",
  "check-solid",
  "circle-check-solid",
  "clock-solid",
  "ellipsis-solid",
  "filter-solid",
  "key-solid",
  "right-from-bracket-solid",
  "trash-can-solid",
  "user-plus-solid",
  "user-shield-solid",
  "user-solid",
];

const loaded = [];

/** Fetch and decode the icons into the browser's image cache when it is idle. */
export function preloadIcons(names) {
  const run = () => {
    for (const name of names) {
      const img = new Image();
      img.decoding = "async";
      img.src = `/icons/${name}.svg`;
      loaded.push(img); // keep a reference until it has loaded
    }
  };
  if ("requestIdleCallback" in window) requestIdleCallback(run, { timeout: 2000 });
  else setTimeout(run, 200);
}
